/* sections/nr-home-stories.liquid: the arrows move the reel along by most
   of its width, and a video review loads and plays in its own card only
   when its "Watch" button is pressed. */
if (!customElements.get('nr-home-stories')) {
  customElements.define(
    'nr-home-stories',
    class extends HTMLElement {
      connectedCallback() {
        const reel = this.querySelector('[data-reel]');
        if (!reel) return;

        this.querySelectorAll('[data-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            reel.scrollBy({ left: Number(button.dataset.step) * reel.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
          });
        });

        this.querySelectorAll('[data-play]').forEach((button) => {
          button.addEventListener('click', () => {
            const story = button.closest('.nr-home-story');
            const video = story && story.querySelector('video');
            if (!video) return;
            if (!video.src) video.src = video.dataset.src;
            video.hidden = false;
            story.classList.add('is-playing');
            video.play();
          });
        });
      }
    }
  );
}
